import { useState, useEffect, useRef } from "react";

export const useVisualViewportAdjustment = () => {
  const [offsetY, setOffset] = useState(0);
  const [viewportHeight, setViewportHeight] = useState(
    window.visualViewport?.height || window.innerHeight
  );

  const initialHeightRef = useRef(window.innerHeight);

  useEffect(() => {
    const handleViewportChange = () => {
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const offset = initialHeightRef.current - viewportHeight;

      setOffset(offset > 0 ? offset : 0);
      setViewportHeight(viewportHeight);
    };

    window.visualViewport?.addEventListener("resize", handleViewportChange);
    window.visualViewport?.addEventListener("scroll", handleViewportChange);

    handleViewportChange();

    return () => {
      window.visualViewport?.removeEventListener("resize", handleViewportChange);
      window.visualViewport?.removeEventListener("scroll", handleViewportChange);
    };
  }, []);

  return { offsetY, viewportHeight };
};
